import React, { useMemo, useState, useEffect } from "react";

import { renderMoney, isNil, filter } from "utils";
import { REPORT_DEFAULT_PER_PAGE } from "const";
import {
    LS_FULL_REPORT_PER_PAGE
} from "const/localStorageKeys";
import { usePrevious } from "hooks";
import TableServer from "components/Table/TableServerSort";
import TableClient from "components/Table/TableClientSort";


const FullReportTable = (props) => {
    const {
        data = [],
        count,
        loading,
        page,


        filters,
        service,
        sort,
        setSort,
        getData
    } = props;

    const defaultPerPage = REPORT_DEFAULT_PER_PAGE;

    const normalizedFilters = filters;

    const isLocalSort = useMemo(() => count < defaultPerPage, [count]);
    const columns = useMemo(() => {
        return [
            {
                label: "Hour",
                dataKey: "dt_hour",
                value: ({ dt_hour }) => dt_hour ? dt_hour : "",
                width: 120,
                sortable: true
            },
            {
                label: "Day",
                dataKey: "dt_day",
                value: ({ dt_day }) => dt_day ? dt_day : "",
                width: 100,
                sortable: true
            },
            {
                label: "Month",
                dataKey: "dt_month",
                value: ({ dt_month }) => dt_month ? dt_month : "",
                width: 100,
                sortable: true
            },
            {
                label: "Year",
                dataKey: "dt_year",
                value: ({ dt_year }) => dt_year ? dt_year : "",
                width: 100,
                sortable: true
            },
            { label: "Period", dataKey: "group_period", minWidth: 160, sortable: false },
            { label: "Range", dataKey: "range_name", minWidth: 330, title: true, sortable: true },
            { label: "Originator", dataKey: "originator_name", minWidth: 280, sortable: true },
            {
                label: "Originator AM",
                dataKey: "originator_manager_name",
                minWidth: 250,
                sortable: true
            },
            {
                label: "Dialer",
                dataKey: "dialer_name",
                value: ({ dialer_name }) => `${dialer_name}`,
                minWidth: 250,
                sortable: true
            },
            {
                label: "Dialer AM",
                dataKey: "dialer_manager_name",
                minWidth: 250,
                sortable: true
            },
            { label: "Supplier", dataKey: "supplier_name", minWidth: 200, sortable: true },
            { label: "Zone (origin)", dataKey: "a_wz_name", minWidth: 180, title: true, sortable: true },
            { label: "Zone (dest)", dataKey: "b_wz_name", minWidth: 180, title: true, sortable: true },
            { label: "Dest (origin)", dataKey: "a_de_name", minWidth: 220, title: true, sortable: true },
            { label: "Dest (dest)", dataKey: "b_de_name", minWidth: 220, title: true, sortable: true },
            { label: "Subdest (origin)", dataKey: "a_sde_name", minWidth: 280, title: true, sortable: true },
            { label: "Subdest (dest)", dataKey: "b_sde_name", minWidth: 280, title: true, sortable: true },
            { label: "A-Number", dataKey: "a_number", minWidth: 160, sortable: true },
            {
                label: "Trunk",
                dataKey: "service_plan_name",
                value: ({ service_plan_name }) => `${service_plan_name}`,
                minWidth: 160,
                sortable: true
            },
            { label: "B-Number", dataKey: "b_number", minWidth: 160, sortable: true },
            {
                label: "Margin",
                dataKey: "sum_margin",
                value: ({ sum_margin, sum_cur_name }) => renderMoney(sum_margin, sum_cur_name),
                minWidth: 120,
                // width: 120,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Duration",
                dataKey: "sum_duration",
                value: ({ sum_duration }) => `${sum_duration || "0"}`,
                minWidth: 100,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Cost",
                dataKey: "sum_cost_dialer",
                value: ({ sum_cost_dialer, sum_cur_name }) => renderMoney(sum_cost_dialer, sum_cur_name),
                minWidth: 120,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Originator Rate",
                value: ({ originator_rate }) => renderMoney(originator_rate),
                dataKey: "originator_rate",
                fullLabel: "Originator Rate",
                width: 120,
                sortable: true,
                align: "right"
            },
            {
                label: "Dialer Rate",
                dataKey: "dialer_rate",
                value: ({ dialer_rate }) => renderMoney(dialer_rate),
                fullLabel: "Dialer Rate",
                width: 100,
                sortable: true,
                align: "right"
            },
            {
                label: "Calls",
                dataKey: "count",
                value: ({ count }) => `${count || "0"}`,
                minWidth: 100,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Message",
                dataKey: "message",
                value: ({ message }) => `${message || "0"}`,
                minWidth: 100,
                sortable: true,
                align: "right",
                isDefault: true
            },
            {
                label: "Message Parts",
                dataKey: "message_parts",
                value: ({ message_parts }) => `${message_parts || ""}`,
                minWidth: 120,
                sortable: true,
                align: "left",
                isDefault: true
            },
            {
                label: "Text",
                dataKey: "text",
                value: ({ text }) => `${text || ""}`,
                minWidth: 320,
                sortable: true,
                align: "left",
                isDefault: true
            },
        ];
    }, []);

    const [tableColumns, setTableColumns] = useState(columns);

    useEffect(() => {
        if (data.length) {
            const groups = normalizedFilters.group_checkbox;
            //SELECT Columns To SHOW
            const filteredData = filter(columns, (column) => {
                return !groups.includes(column.dataKey) ? data.find(item => !isNil(item[column.dataKey])) || column?.isDefault : true;
            });

            setTableColumns(filteredData);
        }
    }, [data, columns, normalizedFilters.group_checkbox]);

    useEffect(() => {
        getReportsItems();
    }, [normalizedFilters]);

    const getReportsItems = (page = 1, perPage = defaultPerPage, _sort = sort) => {
        getData(service, normalizedFilters, page, perPage, sort);
    };

    const tableProps = {
        data: data,
        loading: loading,
        columns: tableColumns,
        originalColumns: tableColumns,
        count: count,
        resizable: true,
        per_page: defaultPerPage,
        page: page,
        getItems: getReportsItems,
        showedCount: count,
        onSort: (column, type) => setSort({ column, type }),
        sortType: sort.type,
        sortColumn: sort.column,

        ispagination: true,
        hidePages: isLocalSort,
        hidePerPage: true,
        // perPageLSKey: LS_FULL_REPORT_PER_PAGE,
    };

    return (<>
        {isLocalSort
            ? <TableClient {...tableProps} />
            : <TableServer {...tableProps} />
        }
    </>);
};

export default FullReportTable;
